import { ControlledBubbleMenu, useRichTextEditorContext } from "mui-tiptap";
import MenuButtonCollapseHeading from "./MenuButtonCollapseHeading";

export const CollapsableBubbleMenu = () => {
  const editor = useRichTextEditorContext();

  const shouldShowMenu = () => {
    if (
      editor &&
      editor.isEditable &&
      editor.can().toggleCollapsableHeading({ defaultOpen: false }) &&
      !editor.view.state.selection.empty
    ) {
      return true;
    }

    return false;
  };

  if (!editor) {
    return <></>;
  }

  return (
    <ControlledBubbleMenu open={shouldShowMenu()} editor={editor}>
      <div>
        <MenuButtonCollapseHeading defaultopen="true" />
        <MenuButtonCollapseHeading />
      </div>
    </ControlledBubbleMenu>
  );
};
